import { z } from 'zod';
import { PCMP_EDIT_LIMITS } from '../constants/pcmpProposal.constants';

// Client checks only mirror the API DTO shapes; business rules (caps, dues,
// taken institute pairs) stay on the API, whose message the dialog shows.

export const pcmpEditReasonSchema = z
  .string()
  .trim()
  .min(1, 'Reason is required')
  .max(PCMP_EDIT_LIMITS.reason, `At most ${PCMP_EDIT_LIMITS.reason} characters`);

export const pcmpOptionalTextSchema = (max: number) =>
  z.string().trim().max(max, `At most ${max} characters`);

/** Blank means "clear" to the API, which wants null for that. */
export const blankToNull = (value: string): string | null => {
  const trimmed = value.trim();
  return trimmed === '' ? null : trimmed;
};

const AMOUNT_PATTERN = /^\d+(\.\d{1,2})?$/;

export const pcmpAmountSchema = (label: string, { positive }: { positive: boolean }) =>
  z
    .string()
    .trim()
    .min(1, `${label} is required`)
    .regex(AMOUNT_PATTERN, 'Enter an amount with at most 2 decimals')
    .refine((value) => !positive || Number(value) > 0, `${label} must be more than 0`)
    .refine((value) => Number(value) <= PCMP_EDIT_LIMITS.maxAmount, `${label} is too large`);

const MOBILE_PATTERN = /^01[3-9]\d{8}$/;

/** The API's normalizePcmpMobile: drops spaces, dashes and a +88 prefix. */
export const normalizeBdMobile = (value: string): string =>
  value.replace(/[\s-]/g, '').replace(/^\+?88(?=01)/, '');

export const isBdMobile = (value: string): boolean => MOBILE_PATTERN.test(normalizeBdMobile(value));

export const pcmpMobileSchema = (label: string) =>
  z
    .string()
    .trim()
    .min(1, `${label} is required`)
    .refine(isBdMobile, 'Enter a valid mobile number, e.g. 01711000000');
